"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.CollapsibleTitle = exports.CollapsibleChevron = exports.CollapsibleButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconFlippingChevron = _interopRequireDefault(require("../IconFlippingChevron")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Wrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Wrapper",
  componentId: "sc-1udtzwt-0"
})(["& .ReactCollapse--collapse{transition:", ";}"], function (p) {
  return p.animate ? 'height 300ms' : 'none';
});

exports.Wrapper = Wrapper;

var CollapsibleButton = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  displayName: "indexstyles__CollapsibleButton",
  componentId: "sc-1udtzwt-1"
})(["color:", ";width:100%;display:flex;padding:0;background:none;border:none;align-items:center;cursor:pointer;text-align:left;"], function (p) {
  return p.theme.colorText;
});

exports.CollapsibleButton = CollapsibleButton;

var CollapsibleTitle = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__CollapsibleTitle",
  componentId: "sc-1udtzwt-2"
})(["flex-grow:1;"]);

exports.CollapsibleTitle = CollapsibleTitle;
var CollapsibleChevron = /*#__PURE__*/(0, _styledComponents["default"])(_IconFlippingChevron["default"]).withConfig({
  displayName: "indexstyles__CollapsibleChevron",
  componentId: "sc-1udtzwt-3"
})(["flex-grow:0;transition:", ";"], function (p) {
  return p.animate ? '300ms ease-in-out' : 'none';
});
exports.CollapsibleChevron = CollapsibleChevron;